import {useI18n} from 'i18n/I18nContext'
import React, {useMemo, useState} from 'react'
import Collapse from 'react-bootstrap/Collapse'
import Form from 'react-bootstrap/Form'
import {useTemplate} from 'TemplateEditor/TemplateProvider'

export function TicketTierVisibilityInput(props: {
  value: number[] | undefined
  name: string
  setFieldValue: (field: string, value: number[]) => void
  disabled?: boolean
}) {
  const {t} = useI18n()
  const {event} = useTemplate()
  const {name, setFieldValue, disabled} = props
  const tiers = event?.tickets ?? []
  const selected = new Set(props.value ?? [])
  const selectedCount = (props.value ?? []).length
  const [open, setOpen] = useState(false)

  const idPrefix = useMemo(() => name.replace(/[^a-zA-Z0-9_-]/g, '-'), [name])

  if (!tiers.length) {
    return (
      <Form.Group className="mb-3 pb-2">
        <span
          className="input__alert alert-bg-2 mb-0 d-block"
          style={{fontSize: 13, lineHeight: 1.4}}
        >
          {t('templateEditor.visibleTicketTiersNoTickets')}
        </span>
      </Form.Group>
    )
  }

  const toggleTier = (id: number) => {
    const next = new Set(selected)
    if (next.has(id)) {
      next.delete(id)
    } else {
      next.add(id)
    }
    setFieldValue(name, [...next])
  }

  return (
    <Form.Group className="mb-3 pb-2">
      <button
        type="button"
        className="d-flex align-items-center justify-content-between w-100 border-0 bg-transparent text-start py-1 px-0 mb-1"
        style={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 1.35,
          color: 'inherit',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        }}
        disabled={disabled}
        aria-expanded={open}
        onClick={() => !disabled && setOpen((v) => !v)}
      >
        <span className="d-flex align-items-center gap-2 min-w-0">
          <i
            className={`fa-regular fa-angle-${open ? 'up' : 'down'}`}
            style={{flexShrink: 0, fontSize: 13, opacity: 0.75}}
            aria-hidden
          />
          <span className="text-truncate">
            {t('templateEditor.visibleTicketTiersToggle')}
          </span>
        </span>
        {selectedCount > 0 ? (
          <span
            className="text-nowrap flex-shrink-0 ms-2"
            style={{fontSize: 12, opacity: 0.8}}
          >
            {t('templateEditor.visibleTicketTiersBadge').replace(
              '{n}',
              String(selectedCount),
            )}
          </span>
        ) : null}
      </button>

      <Collapse in={open}>
        <div className="ps-1 pt-1">
          {tiers.map((tier) => (
            <Form.Check
              key={tier.id}
              type="checkbox"
              id={`tier-${idPrefix}-${tier.id}`}
              className="mb-2 small"
              disabled={disabled}
              checked={selected.has(tier.id)}
              onChange={() => toggleTier(tier.id)}
              label={`${tier.name} (${tier.price <= 0 ? t('eventRow.free') : `${tier.price.toFixed(2)} €`})`}
            />
          ))}
        </div>
      </Collapse>
    </Form.Group>
  )
}
